// extracted by mini-css-extract-plugin
export default {"card":"C6fhRtxy_LolKbYlcUrc__card___","sparkles":"rBF3JPLP8gtTDxX2ZPrH__sparkles___","text":"qDslHU6x3YUY9OtSDtsV__text___"};